import { TFunction } from '#hooks/useI18n';

import { FormValidation } from '@zazume/zzm-base';
import { AsPrimitive, Language, Languages, LanguageVO, PhoneVO, Schema, SchemaOf } from '@zazume/zzm-utils';

import { createFormValidation } from '#/utils/formValidation/toFormValidation';

export interface FormInput {
  name: string;
  surnames: string;
  phoneNumber: string;
  email: string;
  avatar?: any;
  bio?: string | null;
  videoUrl?: string | null;
  lang: AsPrimitive<LanguageVO>;
}

const buildSchema = (t: TFunction): SchemaOf<FormInput> => {
  const requiredMessage = t('general.forms.mandatory');
  return Schema.isObject({
    name: Schema.isString().required(requiredMessage),
    surnames: Schema.isString().required(requiredMessage),
    phoneNumber: Schema.isString()
      .required(requiredMessage)
      .transform((str: string) => str.replace(/ /g, ''))
      .test('is-invalid-phone', t('general.forms.invalid'), PhoneVO.isValid),
    email: Schema.isString().email(t('general.forms.emailError')).required(requiredMessage),
    avatar: Schema.isAnyObject(),
    bio: Schema.isString().nullable(),
    videoUrl: Schema.isString().nullable(),
    lang: Schema.isString()
      .oneOf([...Languages], requiredMessage)
      .required(requiredMessage)
  });
};

export const getSchema = (t: TFunction): FormValidation => createFormValidation(t, buildSchema(t));
